import { render } from "./StoragePoolSelectView.vue?vue&type=template&id=3bda65db&scoped=true"
import script from "./StoragePoolSelectView.vue?vue&type=script&lang=js"
export * from "./StoragePoolSelectView.vue?vue&type=script&lang=js"

import "./StoragePoolSelectView.vue?vue&type=style&index=0&id=3bda65db&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bda65db"]])

export default __exports__